<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta v-if="msgAlerta" :mensagem="msgAlerta" />

    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-char20">
                <label class="label-caption">Tipo</label>
                <select v-model="opcaoSelecionada">
                    <option v-for="opcao in lsOpcoes" :key="opcao.id" :value="opcao.id">{{ opcao.descricao }}</option>
                </select>
            </div>
            <EquipamentoGrupoSelect :ckAddTodos="true" v-model:idSelecionado="idGrupo" />
            <ServicoSelect :ckAddTodos="true" v-model:idSelecionado="idServico" />
            
            <button type="button" class="buttom-icon--map" @click="lerDados" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>
    </div>

    <div v-if="lsDados">
        <MapArrayLegendComponent class="map" :coordinates="lsDados"></MapArrayLegendComponent>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { genericPost } from '@/funcoes/api';
import { globalStore } from '@/globals';
import EquipamentoGrupoSelect from '@/selects/EquipamentoGrupoSelect.vue';
import MapArrayLegendComponent from '@/components/MapArrayLegendComponent.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';
import ServicoSelect from '@/selects/ServicoSelect.vue';

const emit =defineEmits(['close']);
const msgAlerta = ref(null);
const idGrupo = ref(null);
const idServico = ref(null);
const isLoading = ref(false);
const lsDados = ref(null);

const lsOpcoes = ref([
    {id: 'localidades', descricao: 'Localidade'},
    {id: 'regioes', descricao: 'Região'},
    {id: 'individual', descricao: 'OS Individual'},
]);
const opcaoSelecionada = ref('regioes');

const closeForm = () => {emit('close');}

const lerDados = async() => {
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const r = await genericPost(`/os/mapa/${opcaoSelecionada.value}`, {
            idmunicipio: globalStore.idmunicipio,
            idequipamentogrupo: idGrupo.value,
            idservico: idServico.value});
        lsDados.value = r;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}
</script>